// reduxjs toolkit
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import BaseUrl from '../../service/API/base_url';
import { handleSuccess, handleError } from '../../utils/toast';

//List all User
export const viewUser = createAsyncThunk('users', async thunkAPI => {
  try {
    let response = await axios.get(`${BaseUrl}dorm-api/users`);

    //condition
    if (response.status === 200) {
      return response.data;
    } else {
      handleError(response.message);
      return thunkAPI.rejectWithValue(response.data);
    }
  } catch (e) {
    handleError('loading...');
    return thunkAPI.rejectWithValue(e.response.data);
  }
});

//Get single User
export const singleUser = createAsyncThunk('users', async (id, thunkAPI) => {
  try {
    let response = await axios.get(`${BaseUrl}dorm-api/users/${id}`);

    if (response.status === 200) {
      return response.data;
    } else {
      handleError(response.message);
      return thunkAPI.rejectWithValue(response.data);
    }
  } catch (e) {
    handleError('loading...');
    return thunkAPI.rejectWithValue(e.response.data);
  }
});

//Add new User
export const registerUser = createAsyncThunk(
  'users',
  async (userData, thunkAPI) => {
    try {
      //console.log('action user data : ', userData);
      let response = await axios.post(`${BaseUrl}dorm-api/users`, userData);
      //console.log('response : ', response);
      if (response.status === 201) {
        handleSuccess('Register successfully!');
        return response.data.users;
      } else {
        handleError('Invalid Data');
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

// update User
export const updateUser = createAsyncThunk(
  'users',
  async (userData, thunkAPI) => {
    try {
      // response
      let response = await axios.put(
        `${BaseUrl}dorm-api/users/${userData?.id}`,
        userData.formData,
      );
      console.log('response : ', response);
      // condition
      if (response.status === 201) {
        handleSuccess('Change successfull!');
        return response.data.users;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
// Search User
export const deleteUser = createAsyncThunk('users', async (id, thunkAPI) => {
  const userInfo = localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null;
  try {
    let response = await axios.delete(`${BaseUrl}dorm-api/users/${id}`, {
      headers: { Authorization: `Bearer ${userInfo}` },
    });
    if (response.status === 200) {
      handleSuccess('delete successfull !');
      return response.data.users;
    } else {
      handleError(' invalid credentials');
      return thunkAPI.rejectWithValue(response.data);
    }
  } catch (e) {
    handleError('invalid credentials');
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
